import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2024 My Todo App</p>
    </footer>
  );
};

export default Footer;
